(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-signup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const hiddenKey = 'cg_email_signup_hidden_until_v1';
  const acceptedKey = 'cg_email_signup_submitted_v2';
  const sessionKey = 'cg_email_signup_seen_v2';
  const attemptKey = 'cg_signup_submission_recorded_v1';
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { window[storage].setItem(key, value); return true; } catch { return false; } };
  const remember = () => write('localStorage', hiddenKey, String(Date.now() + 30 * 86400000));
  const init = (scope) => scope.querySelectorAll('[data-cg-signup]').forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const panel = root.querySelector('[data-signup-panel]');
    const dialog = root.querySelector('[data-signup-dialog]');
    const collapsed = root.querySelector('[data-signup-collapsed]');
    const reopen = root.querySelector('[data-signup-reopen]');
    const dismiss = root.querySelector('[data-signup-dismiss]');
    const later = root.querySelector('[data-signup-later]');
    const success = root.querySelector('[data-signup-success]');
    const error = root.querySelector('[data-signup-error]');
    const form = root.querySelector('form');
    const heading = root.querySelector('[data-signup-heading]');
    let source = 'footer';
    let timer;
    let lastFocus;
    let previousOverflow;
    let stopped = false;
    let lastInteraction = Date.now();
    let viewed = false;
    const abort = new AbortController();
    const on = (target, name, callback, options = {}) => target.addEventListener(name, callback, { ...options, signal: abort.signal });
    const publish = (name) => {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      window.Shopify?.analytics?.publish?.(name, { source, version: 'cg_acquisition_v3' });
    };
    const stop = () => { stopped = true; clearTimeout(timer); };
    const suppressed = () => Number(read('localStorage', hiddenKey)) > Date.now() || read('localStorage', acceptedKey) === 'true' || read('sessionStorage', sessionKey) === 'true';
    const canUseDialog = typeof dialog.showModal === 'function';
    const open = (origin) => {
      stop();
      source = origin;
      if (dialog.open) return;
      lastFocus = document.activeElement;
      if (canUseDialog) {
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      } else {
        panel.hidden = false;
        collapsed.hidden = true;
      }
      (success || error || heading).focus({ preventScroll: canUseDialog });
      if (!viewed) { publish('cg_signup_view'); viewed = true; }
      write('sessionStorage', sessionKey, 'true');
    };
    const close = () => {
      remember();
      stop();
      if (canUseDialog) dialog.close();
      else { panel.hidden = true; collapsed.hidden = false; reopen.focus(); }
    };
    on(form, 'submit', () => {
      stop();
      write('sessionStorage', attemptKey, 'submitted');
      write('sessionStorage', sessionKey, 'true');
      publish('cg_signup_submit_attempt');
    });
    if (canUseDialog) {
      dialog.append(panel);
      collapsed.hidden = false;
      on(dialog, 'cancel', (event) => { event.preventDefault(); close(); });
      on(dialog, 'keydown', (event) => {
        if (event.key !== 'Tab') return;
        const focusable = [...dialog.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]')]
          .filter((element) => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement;
        if (!first) { event.preventDefault(); return; }
        if (!focusable.includes(active) || (event.shiftKey ? active === first : active === last)) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        }
      });
      on(dialog, 'close', () => {
        document.documentElement.style.overflow = previousOverflow ?? '';
        if (lastFocus?.isConnected) lastFocus.focus({ preventScroll: true });
        else reopen.focus({ preventScroll: true });
      });
      let backdropStart = false;
      on(dialog, 'pointerdown', (event) => { backdropStart = event.target === dialog; });
      on(dialog, 'click', (event) => { if (backdropStart && event.target === dialog) close(); backdropStart = false; });
    }
    dismiss.hidden = false;
    later.hidden = false;
    on(dismiss, 'click', close);
    on(later, 'click', close);
    on(reopen, 'click', () => open('footer'));
    if (success) {
      write('localStorage', acceptedKey, 'true');
      remember();
      if (read('sessionStorage', attemptKey) === 'submitted') {
        publish('cg_signup_submission_accepted');
        try { sessionStorage.removeItem(attemptKey); } catch {}
      }
      open('confirmation_return');
    } else if (error) open('validation_return');
    else if (!canUseDialog && suppressed()) { panel.hidden = true; collapsed.hidden = false; }
    const busy = () => {
      const active = document.activeElement;
      if (document.visibilityState !== 'visible') return true;
      if (active?.matches('input, textarea, select, [contenteditable="true"]')) return true;
      if (document.querySelector('dialog[open], [aria-modal="true"], .cg-header details[open]')) return true;
      if (document.documentElement.style.overflow === 'hidden' || document.body.style.overflow === 'hidden') return true;
      return Date.now() - lastInteraction < 2500;
    };
    const check = () => {
      clearTimeout(timer);
      if (stopped || !root.isConnected || suppressed()) return;
      if (busy()) { timer = setTimeout(check, 2000); return; }
      open(window.matchMedia('(max-width: 749px)').matches ? 'popup_mobile' : 'popup');
    };
    const interaction = (event) => {
      lastInteraction = Date.now();
      if (root.contains(event.target)) return;
      if (event.target.closest('form[action*="/cart"], [data-ajax-add], a[href*="/cart"], a[href*="/checkout"], a[href*="/account"], a[href*="customer_authentication"]')) {
        stop();
      }
    };
    on(document, 'pointerdown', interaction, { passive: true });
    on(document, 'keydown', interaction);
    on(document, 'cart:updated', stop);
    on(window, 'storage', (event) => { if ([hiddenKey, acceptedKey].includes(event.key) && suppressed()) stop(); });
    on(window, 'pagehide', () => { stop(); if (dialog.open) dialog.close(); });
    on(document, 'shopify:section:unload', (event) => { if (event.target.contains(root)) { stop(); if (dialog.open) dialog.close(); abort.abort(); } });
    if (!canUseDialog || success || error || window.Shopify?.designMode || root.dataset.autoPopup !== 'true' || suppressed()) return;
    if (!write('sessionStorage', 'cg_signup_storage_check', 'true') || !write('localStorage', 'cg_signup_storage_check', 'true')) return;
    on(window, 'scroll', () => {
      lastInteraction = Date.now();
    }, { passive: true });
    timer = setTimeout(check, 10000);
  });
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.querySelectorAll('.cg-header').forEach((header) => {
  const desktopMenus = header.querySelectorAll('.cg-nav__details');
  const mobileMenu = header.querySelector('.cg-mobile-nav');
  const mobileGroups = header.querySelectorAll('.cg-mobile-nav__group');

  desktopMenus.forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (!menu.open) return;
      desktopMenus.forEach((otherMenu) => {
        if (otherMenu !== menu) otherMenu.open = false;
      });
    });
  });

  mobileGroups.forEach((group) => {
    group.addEventListener('toggle', () => {
      if (!group.open) return;
      mobileGroups.forEach((otherGroup) => {
        if (otherGroup !== group) otherGroup.open = false;
      });
    });
  });

  header.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    desktopMenus.forEach((menu) => {
      menu.open = false;
    });
    if (mobileMenu) mobileMenu.open = false;
  });

  document.addEventListener('click', (event) => {
    if (header.contains(event.target)) return;
    desktopMenus.forEach((menu) => {
      menu.open = false;
    });
    if (mobileMenu) mobileMenu.open = false;
  });

  header.querySelectorAll('.cg-nav__dropdown a, .cg-mobile-nav__panel a').forEach((link) => {
    link.addEventListener('click', () => {
      desktopMenus.forEach((menu) => {
        menu.open = false;
      });
      if (mobileMenu) mobileMenu.open = false;
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-banner-carousel]').forEach((carousel) => {
        if (carousel.dataset.initialized === 'true') return;
        carousel.dataset.initialized = 'true';

        const slides = Array.from(carousel.querySelectorAll('[data-banner-slide]'));
        const dots = Array.from(carousel.querySelectorAll('[data-banner-dot]'));
        const previous = carousel.querySelector('[data-banner-previous]');
        const next = carousel.querySelector('[data-banner-next]');
        const toggle = carousel.querySelector('[data-banner-toggle]');
        const status = carousel.querySelector('[data-banner-status]');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let activeIndex = 0;
        let userPaused = false;
        let timer;

        if (slides.length < 2) return;

        const showSlide = (index, announce = true) => {
          activeIndex = (index + slides.length) % slides.length;

          slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === activeIndex;
            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
            slide.toggleAttribute('inert', !isActive);
          });

          dots.forEach((dot, dotIndex) => {
            const isActive = dotIndex === activeIndex;
            dot.classList.toggle('is-active', isActive);
            if (isActive) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });

          if (announce && status) {
            status.textContent = `Promotion ${activeIndex + 1} of ${slides.length}: ${slides[activeIndex].dataset.slideLabel}`;
          }
        };

        const stopAutoplay = () => {
          window.clearInterval(timer);
        };

        const startAutoplay = () => {
          stopAutoplay();
          if (carousel.dataset.autoplay !== 'true' || reducedMotion || userPaused) return;
          if (carousel.matches(':hover') || carousel.matches(':focus-within')) return;
          const delay = Number(carousel.dataset.delay) || 6000;
          timer = window.setInterval(() => showSlide(activeIndex + 1, false), delay);
        };

        previous?.addEventListener('click', () => {
          showSlide(activeIndex - 1);
          startAutoplay();
        });

        next?.addEventListener('click', () => {
          showSlide(activeIndex + 1);
          startAutoplay();
        });

        if (reducedMotion && toggle) toggle.hidden = true;

        toggle?.addEventListener('click', () => {
          userPaused = !userPaused;
          toggle.setAttribute('aria-label', userPaused ? 'Resume automatic rotation' : 'Pause automatic rotation');
          toggle.querySelector('[data-banner-pause-icon]').hidden = userPaused;
          toggle.querySelector('[data-banner-play-icon]').hidden = !userPaused;
          if (status) status.textContent = userPaused ? 'Automatic rotation paused.' : 'Automatic rotation resumed.';
          if (userPaused) {
            stopAutoplay();
          } else {
            startAutoplay();
          }
        });

        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            showSlide(Number(dot.dataset.bannerDot));
            startAutoplay();
          });
        });

        carousel.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
          if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
        });
        carousel.addEventListener('mouseenter', stopAutoplay);
        carousel.addEventListener('mouseleave', startAutoplay);
        carousel.addEventListener('focusin', stopAutoplay);
        carousel.addEventListener('focusout', (event) => {
          if (!carousel.contains(event.relatedTarget)) startAutoplay();
        });

        showSlide(0, false);
        startAutoplay();
      });
    };

    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
